import * as React from "react";
import { useEffect } from "react";
import { Select, SelectChangeEvent } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import { CZ, GB } from "country-flag-icons/react/3x2";
import { SELECTED_LANGUAGE_KEY } from "../constants/Constants";

export const languages = [
  { code: "cs", label: "CS", icon: <CZ width={20} /> },
  { code: "en", label: "EN", icon: <GB width={20} /> }
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const selectedLanguage = localStorage.getItem(SELECTED_LANGUAGE_KEY);
    if (selectedLanguage && i18n.resolvedLanguage !== selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
    } else {
      i18n.changeLanguage(languages[0].code);
    }
  }, [i18n]);

  const handleChangeLanguage = (e: SelectChangeEvent) => {
    const newLanguage = e.target.value;
    i18n.changeLanguage(newLanguage);
    localStorage.setItem(SELECTED_LANGUAGE_KEY, newLanguage);
  };

  return (
    <Select
      id="language-selector"
      value={i18n.language}
      renderValue={(value) => languages.find((lng) => lng.code === value)?.icon}
      onChange={handleChangeLanguage}
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none"
        }
      }}
    >
      {languages.map((lng, index) => (
        <MenuItem key={index} value={lng.code}>
          {lng.icon}&nbsp;{lng.label}
        </MenuItem>
      ))}
    </Select>
  );
}
